<ng-container *ngFor="let breadcrumb of breadcrumbs">
  <button
    *ngIf="breadcrumb.show"
    class="btn btn-sm btn-custom-secondary-outline btn-pill text-truncate wm-150 me-1 mt-1"
    (click)="breadcrumb.remove()"
  >
    <i class="fas fa-times"></i> {{ breadcrumb.text }}
  </button>
</ng-container>
